"use strict";

module.exports = __CLIENT__ ? window.__config : {
  development: {
    isProduction: false,
    port: 8000,
    baseUrl: "https://staging2.megascans.se",
    apiBaseUrl: "https://staging2.megascans.se", // 'https://quixel.com',
    cdnBaseUrl: "https://cdn.quixel.com",
    apiZendesk: "https://quixel.zendesk.com",
    ssoBaseUrl: "https://accounts-staging.quixel.com",
    lamdaBaseUrl: "https://1zydji5f55.execute-api.us-west-2.amazonaws.com/dev",
    blogUrl: "https://blog.megascans.se",
    statsBaseUrl: "https://stats.megascans.se/v1",
    optimizelyApiUrl: "https://cdn.optimizely.com",
    assetsCloudFrontUrl: "https://ddinktqu5prvc.cloudfront.net", //https://s3-us-west-2.amazonaws.com/quixel-megascans-assets-staging2',
    staticAssetsCloudFrontUrl: "",
    staticAssetsD2CloudFrontUrl: "",
    freeDownloaderBaseUrl: "http://downloadf.megascans.se/download",
    paidDownloaderBaseUrl: "http://downloadp.megascans.se/download",
    captchaKey: "6LfkF00UAAAAAHLBRo0vINbqSODbbysv_xXf2WFI",
    algoliaIndex: "assets", //'assets-staging',
    forumBaseUrl: "https://support.fab.com/s/?ProductOrigin=Quixeltier1",
    googleAnalyticUID: "UA-51954041-4", //UA-51954041-5 prod
    googleTagManagerUID: "GTM-W5WXGJW", //GTM-N3M6PJT prod
    googleOptimizelyPageLoadTimer: "4000", //Google Optimizely Page load timer for flickering
    epicClientID: "3919f71c66d24a83836f659fd22d49f1",
    epicSSOBaseUrl: "https://accounts.epicgames.com",
    hubspotApiUrl: "https://forms.hubspot.com",
    eolConfigUrl: "https://cdn.quixel.com/quixel/appsConfig/eol-config-dev.json",
    app: {
      name: "Quixel App Development"
    }
  },
  production: {
    isProduction: process.env.ENV_TYPE_IS_PRODUCTION,
    port: 8000,
    baseUrl: process.env.BASE_URL, //'https://megascans.se'
    apiBaseUrl: process.env.MEGASCANS_API_BASE_URL,
    ssoBaseUrl: process.env.SSO_BASE_URL,
    lamdaBaseUrl: process.env.STATIC_LAMDA_FILE_UPLOAD_URL,
    cdnBaseUrl: process.env.STATIC_ASSETS_D2_CLOUDFRONT_URL,
    blogUrl: process.env.BLOG_BASE_URL, //'https://blog.megascans.se'
    apiZendesk: process.env.ZENDESK_API_URL, //'https://quixel.zendesk.com',
    statsBaseUrl: process.env.STATS_URL, //'https://stats.megascans.se/v1',
    assetsCloudFrontUrl: process.env.ASSETS_CLOUDFRONT_URL,
    optimizelyApiUrl: process.env.OPTIMIZELY_API_URL, //'https://cdn.optimizely.com',
    staticAssetsCloudFrontUrl: process.env.STATIC_ASSETS_CLOUDFRONT_URL,
    staticAssetsD2CloudFrontUrl: process.env.STATIC_ASSETS_D2_CLOUDFRONT_URL,
    freeDownloaderBaseUrl: process.env.FREE_ASSET_DOWNLOADER_BASE_URL,
    paidDownloaderBaseUrl: process.env.PAID_ASSET_DOWNLOADER_BASE_URL,
    captchaKey: process.env.CAPTCHAKEY_TOKEN, //'6LfkF00UAAAAAHLBRo0vINbqSODbbysv_xXf2WFI',
    algoliaIndex: process.env.ALGOLIA_INDEX,
    forumBaseUrl: process.env.FORUM_BASE_URL,
    googleAnalyticUID: process.env.GOOGLE_ANALYTICS_UID,
    googleTagManagerUID: process.env.GOOGLE_TAG_MANAGER_UID,
    googleOptimizelyPageLoadTimer: process.env.GOOGLE_OPTIMIZELY_PAGE_LOAD_TIMER, //Google Optimizely Page load timer for flickering
    epicClientID: process.env.EPIC_CLIENT_ID,
    epicSSOBaseUrl: process.env.EPIC_SSO_BASE_URL,
    hubspotApiUrl: process.env.HUBSPOT_API_URL,
    eolConfigUrl: process.env.EOL_CONFIG_URL || "https://cdn.quixel.com/quixel/appsConfig/eol-config-staging.json",
    app: {
      name: "Quixel App Production"
    }
  }
}[process.env.NODE_ENV || "development"];


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 49
// module chunks = 0